import React from 'react'
import { AppContext } from '../../context'

const FilterControl: React.FC = ({}) => {
  return (
    <AppContext.Consumer>
      {({ activePopover, onTogglePopover }) => (
        <div
          title="Filter"
          aria-label="Filter"
          className="mapboxgl-ctrl"
          onClick={() => onTogglePopover('filter')}
        >
          <div
            className={`mapboxgl-ctrl-filter material-icons ${
              activePopover === 'filter' ? 'on' : ''
            }`}
          >
            filter_alt
          </div>
        </div>
      )}
    </AppContext.Consumer>
  )
}

export default FilterControl
